import { Tag } from 'antd';
import React, { FC } from 'react';
import { capitalize } from '../../../../utils/text';

const colors = {
  completed: {
    text: 'var(--color-tag-green)',
    background: 'var(--color-tag-light-green)',
  },
  created: {
    text: 'var(--color-tag-purple)',
    background: 'var(--color-tag-light-purple)',
  },
  edited: {
    text: 'var(--color-tag-yellow)',
    background: 'var(--color-tag-light-yellow)',
  },
  draft: {
    text: 'var(--color-tag-gray)',
    background: 'var(--color-tag-light-gray)',
  },
  inactive: {
    text: 'var(--color-tag-red)',
    background: 'var(--color-tag-light-red)',
  },
};

type Props = {
  status: 'completed' | 'created' | 'edited' | 'draft';
  isBorrowerAccessEnabled: boolean;
}

const Status: FC<Props> = ({ status, isBorrowerAccessEnabled }) => (
  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
    <Tag color={colors[status]?.background} style={{ color: colors[status]?.text, padding: '4px 8px' }}>
      {capitalize(status.replace('-', ' '))}
    </Tag>
    {!isBorrowerAccessEnabled && (
      <Tag color={colors.inactive.background} style={{ color: colors.inactive.text, padding: '4px 8px' }}>
        Report Inactive
      </Tag>
    )}
  </div>
);

export default Status;
